var _path, _circle;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWhiteboardMenuLeft7(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 37.87 29.34",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.83,14.41A19.59,19.59,0,0,0,0,14.41a1,1,0,0,0,0,.53,19.6,19.6,0,0,0,37.79,0A1,1,0,0,0,37.83,14.41ZM18.93,27.34A17.62,17.62,0,0,1,2,14.67a17.6,17.6,0,0,1,33.79,0A17.63,17.63,0,0,1,18.93,27.34Z",
    fill: "#5d5b53"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18.93,
    cy: 14.67,
    r: 8.99,
    fill: "#5d5b53"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteboardMenuLeft7);
export default __webpack_public_path__ + "static/media/whiteboard-menu-left-7.366ba97c2e0a5692dfde664ce4e4d6be.svg";
export { ForwardRef as ReactComponent };